import { TextField } from "@mui/material"
import { Controller, useFormContext } from "react-hook-form"
import { useTranslation } from "react-i18next"

import { StyledHelperText } from "@/components"

import { PassHolderFormData } from "../../schema"

const LastNameField = () => {
  const { t } = useTranslation()

  const { control } = useFormContext<PassHolderFormData>()

  return (
    <Controller
      name="lastName"
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          placeholder={t("passHolderDetails.form.lastName")}
          label={t("passHolderDetails.form.lastName")}
          error={!!error}
          helperText={
            error?.message ? (
              <StyledHelperText helperText={error.message} severity="error" />
            ) : undefined
          }
        />
      )}
    />
  )
}

export default LastNameField
